export default __webpack_public_path__ + "static/media/angry-old-man.e2e079a8.gif";